import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/auth'; 
import { If, createComponent, Slot } from '@lib/util/templateHelpers';
import MenuList from '@/components/MenuList';
import CollapsableSidebarLayout from '@/layouts/CollapsableSidebarLayout';

export default createComponent('DeveloperLayout', {}, function DeveloperLayout ({}, props) {
  const router = useRouter();
  const [ authState ] = useAuthStore();

  useEffect(() => {
    if (authState.ready && !authState.auth) {
      router.replace('/');
      return;
    }
  }, [authState]);

  return (
    <CollapsableSidebarLayout mobileOnly={true}>
      <Slot name='sidebarHeader'>
        Developers
      </Slot>

      <Slot name='sidebar'>
        <MenuList>
          <MenuList.Item href='/developer'>Published Games</MenuList.Item>
          <MenuList.Item href='/developer/add-game'>Submit New Game</MenuList.Item>
          <MenuList.Item href='/developer/iogames-widget'>Cross Promote</MenuList.Item>

          <MenuList.Item href='/developer/purchase-tokens'>Purchase Tokens</MenuList.Item>
          <MenuList.Item href='/developer/spend-tokens'>Spend Tokens</MenuList.Item>
          <MenuList.Item href='/developer/order-history'>Order History</MenuList.Item>
        </MenuList>
      </Slot>

      {
        If(authState.ready && authState.auth, () => (
          <>{props.children}</>
        )).EndIf()
      }
    </CollapsableSidebarLayout>
  );
});
